import TitleWrapper from "../../../../../components/ui/titlewrapper/TitleWrapper";
import { validationTypes } from "../../../../../components/forms/libs/data/ValidationTypes";
import { FormFieldTypes } from "../../../../../components/forms/libs/data/formFieldType";

const initState = {
    courseAddressType: 'ipas',
    address: '',
    postalCode: 1,
    howToGetThere: ''
};

export const CourseLocationFormData = {
    name: "CourseLocationFormData",
    initialState: initState,
    section: [
        {
            title: "Course Location Information Section",
            row: {},
            style: {
                sectionStyle: "verticle-form mb-3 form-card row",
            },
            wrapperTemplate: <TitleWrapper title="Course Location" />,
            fields: [
                {
                    id: "courseAddressType",
                    label: "Registration Approval ",
                    Field_Name: "Registration Approval",
                    fieldType: FormFieldTypes.RADIOBUTTON,
                    dataField: "courseAddressType",
                    fieldSetting: {
                        allowSpace: true,
                        options: [
                            { value: "ipas", label: "IPAS" },
                            { value: "otherAddress", label: "Other Address" },
                        ],
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-12 radioStyle col-md-12 ",
                    },
                },
                {
                    id: "address",
                    label: "Address",
                    Field_Name: "Address",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "address",
                    fieldSetting: {
                        placeholder: "Please Enter Name",
                        allowSpace: true,
                        textareaRows: 4,
                        isDisable: initState.courseAddressType === "ipas" ? true : false

                    },
                    style: {
                        containerCss: "col-lg-4 col-md-4 validation-left-0 mb-2 mt-2",
                    },
                },
                {
                    id: "postalCode",
                    label: "Postal Code",
                    Field_Name: "Postal Code",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "postalCode",
                    fieldSetting: {
                        placeholder: "Please Enter Name",
                        allowSpace: true,
                        textareaRows: 4,
                        isDisable: initState.courseAddressType === "ipas" ? true : false
                    },
                    style: {
                        containerCss: "col-lg-4 col-md-4 validation-left-0 mb-2 mt-2",
                    },
                },
                {
                    id: "howToGetThere",
                    label: "How to get there",
                    Field_Name: "How to get there",
                    fieldType: FormFieldTypes.TEXTEDITOR,
                    dataField: "howToGetThere",
                    fieldSetting: {
                        allowSpace: true,
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-xxl-12 col-xl-12 col-md-12 col-12 mt-2",
                    },
                },
            ],
        },
    ],
    formSetting: {
        isViewOnly: false,
    },
};
